// 导入 react 的核心文件
import React from 'react';
// 导入 ReactDOM （在前端使用 react 时，需要配合 ReactDOM 使用）
import ReactDOM from 'react-dom/client';
// 导入 index.css 文件
import './index.css';
// 导入性能测试的文件
import reportWebVitals from './reportWebVitals';
// 启用客户端路由
import { BrowserRouter } from 'react-router-dom'
// 导入 axios 的配置文件
import './request/axiosConfig'

// 导入跟组件 （App.js 定义了一个函数组件）
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>

  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);

reportWebVitals();
